ux-iws-sf-captcha {
    display: block;
}
